import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutoTargetDirective } from './auto-target.directive';
import { RouterLinkDirective } from './router-link.directive';

@NgModule({
  declarations: [RouterLinkDirective, AutoTargetDirective],
  imports: [CommonModule],
  exports: [RouterLinkDirective, AutoTargetDirective]
})
export class RouterLinkModule {}

export * from './auto-target.directive';
export * from './empty-route.guard';
export * from './router-link.directive';
export * from './router-helper.service';
